import { render, staticRenderFns } from "./FinishedRoundView.vue?vue&type=template&id=0f584952&scoped=true"
import script from "./FinishedRoundView.vue?vue&type=script&lang=js"
export * from "./FinishedRoundView.vue?vue&type=script&lang=js"
import style0 from "./FinishedRoundView.vue?vue&type=style&index=0&id=0f584952&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f584952",
  null
  
)

export default component.exports